import * as PopoverPrimitive from "@radix-ui/react-popover";
import { useTheme } from "next-themes";
import { F, th } from "@/lib/bricks";

/**
 * InfoTip — a small "i" that opens the detail a screen used to print inline.
 * Tap or click to open (works on touch), Esc / outside click to close.
 */
export default function InfoTip({ children, label = "More info", side = "top", align = "center", style = {} }) {
  const { resolvedTheme } = useTheme();
  const p = th(resolvedTheme === "dark");
  return (
    <PopoverPrimitive.Root>
      <PopoverPrimitive.Trigger asChild>
        <button type="button" aria-label={label} data-testid="info-tip"
          onClick={(e) => e.stopPropagation()}
          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 44, height: 44, margin: -14, padding: 0,
            border: "none", background: "transparent", cursor: "pointer", verticalAlign: "middle", flexShrink: 0, position: "relative" }}>
          {/* 16px mark, 44px target; the negative margin keeps the 16px footprint in the line */}
          <span aria-hidden="true" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 16, height: 16,
            border: `1px solid ${p.hairS}`, borderRadius: 2, color: p.ink3, boxSizing: "border-box",
            fontFamily: F.display, fontSize: 10, fontWeight: 600, lineHeight: 1, ...style }}>i</span>
        </button>
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content side={side} align={align} sideOffset={6} collisionPadding={12}
          onClick={(e) => e.stopPropagation()}
          style={{ zIndex: 60, maxWidth: 280, padding: "10px 12px", background: p.surf, color: p.ink2, border: `1px solid ${p.hairS}`,
            borderRadius: 2, boxShadow: "0 6px 24px rgba(20,17,14,0.10)", fontFamily: F.display, fontSize: 12.5, lineHeight: 1.5 }}>
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
